module.exports = __webpack_public_path__ + "img/subject_banner5.103fd8c8.png";